import { supabase } from 'src/lib/supabaseClient';

export interface Subject {
  id: string;
  name: string;
  description: string | null;
  icon: string | null;
  color: string | null;
  category: string | null;
  display_order: number | null;
  created_at: string;
  updated_at: string;
}

export const subjectsService = {
  /**
   * Get all active subjects using Supabase RPC
   */
  async getActiveSubjects(): Promise<Subject[]> {
    const { data, error } = await supabase.rpc('get_active_subjects');
    
    if (error) {
      console.error('Error fetching active subjects:', error);
      throw new Error(`Failed to fetch subjects: ${error.message}`);
    }
    
    return data || [];
  }
};